module.exports = __webpack_public_path__ + "static/media/invoice.62928a7d.svg";